import React from "react";
import { Container, Grid, Typography, IconButton, Box, Stack } from "@mui/material";
import { Instagram } from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Link as ScrollLink } from "react-scroll";
import Iframe from "react-iframe";
import crescent from "../Images/Crescent.png";
import { colors, fonts } from "../theme";

const quickLinks = [
  { to: "home-section", label: "Home" },
  { to: "about-section", label: "About" },
  { to: "programs-section", label: "Programs" },
  { to: "accreditation-section", label: "Accreditation" },
  { to: "impact-section", label: "Impact" },
  { to: "roadmap-section", label: "Roadmap" },
  { to: "contacts-section", label: "Partner With Us" },
];

const mapUrl =
  "https://www.google.com/maps?q=AVK+Nagar,+Salem+636004,+Tamil+Nadu,+India&output=embed";

// Clickable footer contact rows — subtle slide + lighten on hover.
const footerLinkSx = {
  color: "inherit",
  textDecoration: "none",
  width: "fit-content",
  transition: "transform .2s ease, opacity .2s ease",
  "&:hover": { transform: "translateX(4px)", opacity: 0.85 },
};

const Footer = () => {
  return (
    <footer>
      <Box sx={{ background: colors.navy, color: colors.white, pt: 6, pb: 3 }}>
        <Container>
          <Grid container spacing={{ xs: 3, md: 4 }}>
            {/* Brand */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "inline-block", mb: 2 }}>
                <img src={crescent} alt="Crescent EdTech" style={{ maxHeight: 52, display: "block" }} />
              </Box>
              <Typography sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.9rem", lineHeight: 1.7, mb: 2 }}>
                Your Academic Partner for Research, Innovation &amp; Technology — building
                accreditation-ready outcomes through long-term institutional partnership.
              </Typography>
              <IconButton
                href="https://www.instagram.com/crescentedtech/"
                target="_blank"
                rel="noopener"
                sx={{ color: colors.white, bgcolor: "rgba(255,255,255,0.08)", "&:hover": { bgcolor: colors.pink } }}
              >
                <Instagram />
              </IconButton>
            </Grid>

            {/* Quick links */}
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={{ fontFamily: fonts.heading, fontWeight: 700, mb: 2 }}>Explore</Typography>
              <Stack spacing={1.2}>
                {quickLinks.map((l) => (
                  <ScrollLink
                    key={l.to}
                    to={l.to}
                    smooth={true}
                    duration={800}
                    offset={-70}
                    style={{ color: "rgba(255,255,255,0.78)", textDecoration: "none", cursor: "pointer", fontSize: "0.9rem" }}
                  >
                    {l.label}
                  </ScrollLink>
                ))}
              </Stack>
            </Grid>

            {/* Contact */}
            <Grid item xs={12} sm={6} md={5}>
              <Typography sx={{ fontFamily: fonts.heading, fontWeight: 700, mb: 2 }}>Reach Us</Typography>
              <Stack spacing={1.5} sx={{ mb: 2 }}>
                <Stack direction="row" spacing={1.2} alignItems="flex-start">
                  <LocationOnIcon sx={{ color: colors.blue, fontSize: 20, mt: "2px" }} />
                  <Typography sx={{ color: "rgba(255,255,255,0.78)", fontSize: "0.88rem", lineHeight: 1.6 }}>
                    196/8, Gokulakrishnan Street, AVK Nagar, Opp. New Bus Stand, Salem – 636004, Tamil Nadu, India
                  </Typography>
                </Stack>
                <Stack
                  component="a"
                  href="tel:+918667002959"
                  direction="row"
                  spacing={1.2}
                  alignItems="center"
                  sx={footerLinkSx}
                >
                  <CallIcon sx={{ color: colors.blue, fontSize: 20 }} />
                  <Typography sx={{ color: "rgba(255,255,255,0.78)", fontSize: "0.88rem" }}>+91 86670 02959</Typography>
                </Stack>
                <Stack
                  component="a"
                  href="mailto:reachus@crescentedtech.in"
                  direction="row"
                  spacing={1.2}
                  alignItems="center"
                  sx={footerLinkSx}
                >
                  <EmailIcon sx={{ color: colors.blue, fontSize: 20 }} />
                  <Typography sx={{ color: "rgba(255,255,255,0.78)", fontSize: "0.88rem" }}>reachus@crescentedtech.in</Typography>
                </Stack>
              </Stack>
              <Box sx={{ borderRadius: 2, overflow: "hidden", border: "1px solid rgba(255,255,255,0.15)" }}>
                <Iframe
                  url={mapUrl}
                  width="100%"
                  height="160px"
                  styles={{ border: 0, display: "block" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.12)", mt: 4, pt: 2.5 }}>
            <Grid container justifyContent="center" alignItems="center" spacing={1}>
              <Grid item xs={12}>
                <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.82rem", textAlign: "center" }}>
                  © 2026 Crescent EdTech. All rights reserved.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </footer>
  );
};

export default Footer;
